module.exports = __webpack_public_path__ + "static/stephen-king-6fb828a9fd293e49ef434b90a7b581ff.jpg";